import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedName from 'I18n/components/FormattedName';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux'; // @ts-expect-error Untyped module

import UIUnauthedHubSpotUserAvatar from 'ui-addon-avatars/UIUnauthedHubSpotUserAvatar';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getFlowKey } from '../routing/getFlowKey';
import { getAuthenticatedUser } from '../store/auth/selectors';
import { Step } from '../views/Step';
import { AccountCardContinueButton, AccountCardEmail, AccountCardUserName, StyledAccountCard } from './AccountCard.styles';
export const AccountCard = ({
  continueWithThisUser,
  message
}) => {
  const user = useSelector(getAuthenticatedUser);
  const shouldShowBoxAccountCard = getFlowConfig().shouldShowBoxAccountCard;
  const flowKey = getFlowKey();
  const defaultMessage = isValidI18nKey(`views.${Step.ExistingUser}.${flowKey}.buttonText`) ? `views.${Step.ExistingUser}.${flowKey}.buttonText` : `views.${Step.ExistingUser}.buttonText`;

  if (!user) {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledAccountCard, {
    shouldShowBoxAccountCard: shouldShowBoxAccountCard,
    children: /*#__PURE__*/_jsxs("div", {
      className: "text-center width-100",
      children: [/*#__PURE__*/_jsx(UIUnauthedHubSpotUserAvatar, {
        className: "m-x-0",
        hubSpotUserEmail: user.email ? user.email : '',
        size: "xl"
      }), /*#__PURE__*/_jsx(AccountCardUserName, {
        children: /*#__PURE__*/_jsx(FormattedName, {
          familyName: user.lastName,
          givenName: user.firstName
        })
      }), /*#__PURE__*/_jsx(AccountCardEmail, {
        children: user.email
      }), /*#__PURE__*/_jsx(AccountCardContinueButton, {
        "data-selenium": `${Step.ExistingUser}_continueWithUserButton`,
        use: "primary",
        onClick: continueWithThisUser,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message || defaultMessage
        })
      })]
    })
  });
};